import {
	Box,
	Card,
	CardContent,
	FilledInput,
	FormControl,
	FormGroup,
	FormLabel,
	IconButton,
	makeStyles,
	useTheme
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { PhotoCamera } from "@material-ui/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import componentStyles from "../../assets/theme/views/admin/profile.js";
import Loader from "../../components/Loader/loader.js";
import { withAppContext } from "../../contextApi/Auth/index.js";
import { BACKEND_URL, BACKENDImage_URL } from "../../env.js";

const useStyles = makeStyles(componentStyles);

function CreateUpdateSlider({ open, handleClose, UpdateId, GetAllCategories }) {
	const classes = useStyles();
	const theme = useTheme();
	const [Loading, setLoading] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);
	const [Image, setImage] = useState(null);
	// console.log(UpdateId);

	const handleImageChange = (event) => {
		if (event.target.files && event.target.files[0]) {
			setImage(event.target.files[0]);
			setSelectedImage(URL.createObjectURL(event.target.files[0]));
		}
	};
	function GetSliderInfo() {
		axios
			.get(`${BACKEND_URL}/slider/${UpdateId}`, {
				headers: {
					token: localStorage.getItem("Token"),
				},
			})
			.then((res) => {
				console.log(res.data);
				setImage(res.data.getSlider.Image);
			})
			.catch((res) => console.log(res));
	}

	useEffect(() => {
		GetSliderInfo();
	}, [UpdateId]);

	const [Name, setName] = useState('');

	const handleCreateSubmit = (e) => {
			setLoading(true);

			const formData = new FormData();
			formData.append('Image', Image);
			const config = {
				method: UpdateId ? "put" : "post",
				url: UpdateId ? `${BACKEND_URL}/slider/${UpdateId}` : `${BACKEND_URL}/slider`,
				data: formData,
				headers: {
					token: localStorage.getItem("Token")
				}
			};
			axios(config)
				.then((res) => {
					GetAllCategories();
					handleClose();
					setName(' ');
					setSelectedImage("")
					setImage("")
					setLoading(false);
					console.log(res);
					toast.success(`Successfully added ${Name} Slider`, {
						position: "top-right",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: false,
					});
				})
				.catch((res) => {
					setLoading(false);
					toast.error(`Invalid error`, {
						position: "top-right",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: false,
					});
				});
	};
	const enterLogin = (e) => {
		console.log(e);
		if (e?.keyCode === 13) {
			handleCreateSubmit();
		}
	}
	return (
		<div>
			<Dialog open={open} onClose={() => handleClose()} aria-labelledby="draggable-dialog-title">
				<DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
					Create Slider
				</DialogTitle>
				<DialogContent>
					<Card classes={{ root: classes.cardRoot }}>
						<Box component={CardContent} classes={{ root: classes.ptMd4 }} paddingTop="0!important">
							<FormGroup>
								<FormLabel>Upload Image</FormLabel>
								<FormControl
									variant="filled"
									component={Box}
									width="100%"
									marginBottom="1rem!important"
								>
									<div className={classes.uploadButton}>
										<input
											accept="image/*"
											style={{ display: 'none' }}
											id="contained-button-file"
											type="file"
											onChange={handleImageChange}
										/>
										<label htmlFor="contained-button-file">
											<IconButton color="primary" aria-label="upload picture" component="span">
												<PhotoCamera />
											</IconButton>
										</label>
									</div>
									{selectedImage || Image && <img src={selectedImage ? selectedImage : `${BACKENDImage_URL}${Image}`} alt="Selected" className={classes.imagePreview} />}
								</FormControl>
							</FormGroup>
						</Box>
					</Card>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={() => handleClose()}>
						Cancel
					</Button>
					<Button onClick={() => handleCreateSubmit()}>
						{Loading ? <Loader cumtomStyle={{ position: "unset", }} /> : UpdateId ? "Update Slider" : "Create Slider"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default withAppContext(CreateUpdateSlider);
